<ng-container *ngIf="content">
  <section>
    <h1 class="font-heading-3">
      <div class="font-body-1 nordic-blue-900-text light-type">{{ 'flightsTo' | finLocalization }}</div>
      <div class="font-heading-1 nordic-blue-900-text">{{ content | finMap: 'title' }}</div>
    </h1>
    <p class="ms-medium-y" *ngIf="content.detailText"><span [innerHTML]="content | finMap: 'detailText'"></span></p>
  </section>
</ng-container>
